import { supabase } from "./api";

export const revalidate = 0;

export async function getAllData() {
    const { data, error } = await supabase.from("resourcecenterview").select();

    if (error) {
        throw new Error(`Failed to delete data: ${error.message}`);
    }

    return data;
}

export async function getIdData(id) {
    const { data, error } = await supabase
        .from("resourcecenterview")
        .select()
        .eq("id", id);
    if (error) {
        throw new Error(`Failed to delete data: ${error.message}`);
    }

    return data;
}

export async function addData(adata) {
    const { data, error } = await supabase
        .from("resourcecenterview")
        .insert(adata)
        .select();

    if (error) {
        throw new Error(`Failed to delete data: ${error.message}`);
    }

    return data;
}

export async function updateData(udata) {
    const { data, error } = await supabase
        .from("resourcecenterview")
        .update(udata)
        .eq("id", udata.id)
        .select();

    if (error) {
        throw new Error(`Failed to delete data: ${error.message}`);
    }

    return data;
}

export async function deleteIdData(id) {
    const { data, error } = await supabase
        .from("resourcecenter")
        .delete()
        .eq("id", id);

    if (error) {
        throw new Error(`Failed to delete data: ${error.message}`);
    }

    return data;
}
